module.exports = __webpack_public_path__ + "img/tws9.e4802581.png";